export const getProjectCategories = (state) => state.project_categories
export const getProjectCategoryGroups = (state) => state.project_category_groups
export const getCurrentProjectCategory = (state) => state.current_project_category